import React from 'react'
import ConstructionPage from '../components/UnderConstruction'
import '../styles/main.scss'

const LayoutWrapper = () => (
  <ConstructionPage />
);

export default LayoutWrapper
